__webpack_require__.p = "/2025-10-01_04-04-35-opencast-18150951027-dependabot-npm_and_yarn-react-i18next-16-0-0/";